<template>
  <div class="newSpecialistProfiles">
    <!-- 标题和返回 -->
    <div class="title_box">
      <h4>{{navigationTitle}}</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回</el-button>
    </div>
    <!-- 标题和返回 -->
    <!-- 这里边是一个表单 -->
    <el-form
      ref="reference"
      :model="reference"
      size="small"
      label-width="80px"
      label-position="top"
      :rules="rules"
      class="form-p"
    >

      <div class="feather">
        <img src="../../assets/image/books/yumao.png">
      </div>

      <el-card class="box-card">
        <el-form-item
          label="姓名"
          prop="expert_name"
        >
          <el-col :span="13">
            <el-input
              v-model="reference.expert_name"
              placeholder="请输入姓名"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item
          label="手机号"
          prop="phone"
        >
          <el-col :span="13">
            <el-input
              v-model="reference.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item
          label="身份证"
          prop="id_card"
        >
          <el-col :span="13">
            <el-input
              v-model="reference.id_card"
              placeholder="请输入身份证"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所在医院">
          <el-col :span="13">
            <el-input
              v-model="reference.hospital"
              placeholder="请输入所在医院"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所属科室">
          <el-select
            v-model="reference.category_id"
            placeholder="请选择"
            filterable
            style="width:830px;"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职称">
          <el-col :span="13">
            <el-input
              v-model="reference.title"
              placeholder="请输入职称"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="开户银行">
          <el-col :span="13">
            <el-input
              v-model="reference.bank_of_deposit"
              placeholder="请输入开户银行"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="开户支行">
          <el-col :span="13">
            <el-input
              v-model="reference.sub_branch"
              placeholder="请输入开户支行"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="银行卡号">
          <el-col :span="13">
            <el-input
              v-model="reference.brank_card"
              placeholder="请输入银行卡号"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="background: #484c7f"
            @click="submitForm('reference')"
          >保存</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template> 
 
<script>
export default {
  name: 'newSpecialistProfiles',
  data () {
    return {
      options: [],
      navigationTitle: '新建专家档案',
      reference: {
        expert_name: '',//专家姓名
        phone: '',//手机号
        id_card: '',//身份证号码
        hospital: '',//所在医院 
        category_id: '',//所在科室
        title: '',//职称
        bank_of_deposit: '',//开户银行
        sub_branch: '',//开户支行
        brank_card: '',//银行卡号
        ent_id: '',//企业id 
        id: '',//项目id
        library_expert_id: '',//专家档案id 
      },
      rules: {
        expert_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        id_card: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ]
      },
    }
  },
  created () {
    if (this.$route.query.library_expert_id != "" && this.$route.query.library_expert_id != null && this.$route.query.library_expert_id != undefined) this.compileEntry(this.$route.query.library_expert_id)
    if (this.$route.query.ent_id != '') this.reference.ent_id = this.$route.query.ent_id
    this.getSectionsList()
  },
  methods: {
    //点击编辑进来的  
    async compileEntry (id) {
      this.navigationTitle = '编辑档案'
      const { data: data } = await this.$http.post("archives/expertDetail", {
        id
      })
      this.reference = data.data
      if (this.$route.query.ent_id != '') this.reference.ent_id = this.$route.query.ent_id
      if (this.$route.query.library_ent_id != '') this.reference.library_ent_id = this.$route.query.library_ent_id
      if (this.$route.query.library_expert_id != '') this.reference.library_expert_id = this.$route.query.library_expert_id
    },
    //获取科室
    async getSectionsList () {
      const { data: data } = await this.$http.post('cate/list', { type: '1' })
      this.options = data.data
    },
    //滚动条定位到第一个校验失败的div的位置
    locateToErr () {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单 
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.library_expert_id != '' && this.$route.query.library_expert_id != undefined && this.$route.query.library_expert_id != null) {
            this.editInfoExpert()
          } else {
            this.getInfoExpert()
          }
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //新建提交接口
    async getInfoExpert () {
      const { data: data } = await this.$http.post("archives/create", this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.back()
    },
    //编辑提交接口  
    async editInfoExpert () {
      const { data: data } = await this.$http.post("archives/edit", this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.back()
    },
    //返回
    backProject () {
      this.$router.back()
    }
  }
}
</script>

<style lang='less' scoped>
.newSpecialistProfiles {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    margin-bottom: 40px;
  }
  // 上传图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
  }
  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }
  // 上传文件
  .uploads {
    display: flex;
    .upload-demo {
      display: flex;
      align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }
      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;
        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }
    .ticks {
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  //新的
  .uploads-box {
    position: relative;
    .upload-demo {
      align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }
      .box {
        position: absolute;
        top: 1px;
        left: 80px;
        width: 421px;
        height: 32px;
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
      }
    }
    .ticks {
      position: absolute;
      top: -10px;
      left: 500px;
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  //上传文件ui el-upload-list el-upload-list--text
  /deep/ .el-upload-list {
    z-index: 9999;
    position: absolute;
    top: -5px;
    left: 80px;
    width: 410px;
    overflow: hidden;
  }

  .form-p {
    position: relative;
    .feather {
      position: absolute;
      width: 130px;
      height: 130px;
      right: 0;
      top: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>